export const metisPools = [
  {
    id: 'metis-bifi-maxi',
    logo: 'single-assets/BIFI.png',
    name: 'BIFI Maxi',
    token: 'BIFI',
    tokenDescription: 'Beefy',
    tokenAddress: '0xe6801928061CDbE32AC5AD0634427E140EFd05F9',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooMetisBIFI',
    earnedTokenAddress: '0xEA01ca0423acb8476E1D3Bae572021c2aA9bd410',
    earnContractAddress: '0xEA01ca0423acb8476E1D3Bae572021c2aA9bd410',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'BIFI',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Beefy',
    assets: ['BIFI'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_NONE',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'Maxi',
    withdrawalFee: '0.05%',
    buyTokenUrl:
      'https://netswap.io/#/swap?outputCurrency=0xe6801928061cdbe32ac5ad0634427e140efd05f9',
    createdAt: 1642600646,
  },
  {
    id: 'tethys-rftm-metis',
    name: 'rFTM-METIS LP',
    token: 'rFTM-METIS LP',
    tokenDescription: 'Tethys',
    tokenAddress: '0x74Ca39F7aB9B685B8eA8c4ab19E7Ab6b474Dd22D',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysFTM-METIS',
    earnedTokenAddress: '0x55Dd65993cB918cdA55eA02FCc6D417A364833d9',
    earnContractAddress: '0x55Dd65993cB918cdA55eA02FCc6D417A364833d9',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-rftm-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['FTM', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_LOW',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0xa9109271abcf0C4106Ab7366B4eDB34405947eED',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0xa9109271abcf0C4106Ab7366B4eDB34405947eED',
    createdAt: 1647625639,
  },
  {
    id: 'tethys-metis-ravax',
    name: 'rAVAX-METIS LP',
    token: 'rAVAX-METIS TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0x3Ca47677e7D8796e6470307Ad15c1fBFd43f0D6F',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysAVAX-METIS',
    earnedTokenAddress: '0x45703CED1880604745Cfc8A98E727F70fFB08674',
    earnContractAddress: '0x45703CED1880604745Cfc8A98E727F70fFB08674',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-metis-ravax',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['AVAX', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_LOW',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0xE253E0CeA0CDD43d9628567d097052B33F98D611',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0xE253E0CeA0CDD43d9628567d097052B33F98D611',
    createdAt: 1647625860,
  },
  {
    id: 'tethys-dai-metis',
    name: 'DAI-METIS LP',
    token: 'DAI-METIS LP',
    tokenDescription: 'Tethys',
    tokenAddress: '0xCc15d8f93be780aD78fD1A016fB0F15F2543b5Dc',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysDAI-METIS',
    earnedTokenAddress: '0xfE118360BEAc5c2ac9dA77D2366b8738bBFeb2d9',
    earnContractAddress: '0xfE118360BEAc5c2ac9dA77D2366b8738bBFeb2d9',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-dai-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['DAI', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_LOW',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
      'OVER_COLLAT_ALGO_STABLECOIN',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0x4651B38e7ec14BB3db731369BFE5B08F2466Bd0A',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0x4651B38e7ec14BB3db731369BFE5B08F2466Bd0A',
    createdAt: 1647626163,
  },
  {
    id: 'netswap-byte-m.usdc',
    name: 'BYTE-m.USDC LP',
    token: 'BYTE-m.USDC LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x3Ab6be89ED5A0d4FDD412c246F5e6DdD250Dd45c',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapBYTE-m.USDC',
    earnedTokenAddress: '0xbFF1EF9e84121f7CaEd2416b1c1B8aE81715F96a',
    earnContractAddress: '0xbFF1EF9e84121f7CaEd2416b1c1B8aE81715F96a',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-byte-m.usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['BYTE', 'mUSDC'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x721532bC0dA5ffaeB0a6A45fB24271E8098629A7/0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x721532bC0dA5ffaeB0a6A45fB24271E8098629A7&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    createdAt: 1647532435,
  },
  {
    id: 'netswap-wbtc-metis',
    name: 'WBTC-METIS',
    token: 'WBTC-METIS LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0xE0cc462fe369146BAef2306EC6B4BF26704eE84e',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapWBTC-METIS',
    earnedTokenAddress: '0x4e9E8A5Ce321cE0a380c1CEab388c673180AF657',
    earnContractAddress: '0x4e9E8A5Ce321cE0a380c1CEab388c673180AF657',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-wbtc-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['WBTC', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl: 'https://netswap.io/#/add/METIS/0xa5B55ab1dAF0F8e1EFc0eB1931a957fd89B918f4',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=METIS&outputCurrency=0xa5B55ab1dAF0F8e1EFc0eB1931a957fd89B918f4',
    createdAt: 1645533903,
  },
  {
    id: 'netswap-wbtc-m.usdt',
    name: 'WBTC-m.USDT',
    token: 'WBTC-m.USDT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0xAd9b903451dfdc3D79d2021289F9d864fd8c8119',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapWBTC-m.USDT',
    earnedTokenAddress: '0x23343d47111AbC4b1699fED61276c06Ff8a0D081',
    earnContractAddress: '0x23343d47111AbC4b1699fED61276c06Ff8a0D081',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-wbtc-m.usdt',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['WBTC', 'mUSDT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_LOW',
      'MCAP_LARGE',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0xa5B55ab1dAF0F8e1EFc0eB1931a957fd89B918f4/0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC&outputCurrency=0xa5B55ab1dAF0F8e1EFc0eB1931a957fd89B918f4',
    createdAt: 1645536038,
  },
  {
    id: 'tethys-wbtc-metis',
    name: 'WBTC-METIS',
    token: 'WBTC-METIS TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0xA0081C6D591c53Ae651bD71B8d90C83C1F1106C2',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysWBTC-METIS',
    earnedTokenAddress: '0x0FB94775d16e14627678391D24E4576fdA05E3ed',
    earnContractAddress: '0x0FB94775d16e14627678391D24E4576fdA05E3ed',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-wbtc-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['WBTC', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0xa5B55ab1dAF0F8e1EFc0eB1931a957fd89B918f4',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0xa5B55ab1dAF0F8e1EFc0eB1931a957fd89B918f4',
    createdAt: 1645526396,
  },
  {
    id: 'tethys-m.usdc-m.usdt',
    name: 'm.USDC-m.USDT LP',
    token: 'm.USDC-m.USDT TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0x6c4768d4b3acD4a3fF01F179FaffDaEbe084D12D',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysm.USDC - m.USDT',
    earnedTokenAddress: '0xc674cf138415244041d512Edf1c7943D99dD229F',
    earnContractAddress: '0xc674cf138415244041d512Edf1c7943D99dD229F',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-m.usdc-m.usdt',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['mUSDC', 'mUSDT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_NONE',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21&outputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0x6c4768d4b3acD4a3fF01F179FaffDaEbe084D12D',
    createdAt: 1644871173,
  },
  {
    id: 'tethys-tethys-metis',
    name: 'TETHYS-METIS LP',
    token: 'TETHYS-METIS TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0xc9b290FF37fA53272e9D71A0B13a444010aF4497',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysTETHYS-METIS',
    earnedTokenAddress: '0xC8ca2254bCBA3aD8511Faff54e0b9941D0424502',
    earnContractAddress: '0xC8ca2254bCBA3aD8511Faff54e0b9941D0424502',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-tethys-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['TETHYS', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0x69fdb77064ec5c84FA2F21072973eB28441F43F3',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0x69fdb77064ec5c84FA2F21072973eB28441F43F3',
    createdAt: 1642623428,
  },
  {
    id: 'tethys-m.usdt-metis',
    name: 'm.USDT-METIS LP',
    token: 'm.USDT-METIS TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0x8121113eB9952086deC3113690Af0538BB5506fd',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysm.USDT-METIS',
    earnedTokenAddress: '0x462066c67A729572668B6CF79151c0ed67734D91',
    earnContractAddress: '0x462066c67A729572668B6CF79151c0ed67734D91',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-m.usdt-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['mUSDT', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    createdAt: 1642623639,
  },
  {
    id: 'tethys-metis-m.usdc',
    name: 'm.USDC-METIS LP',
    token: 'm.USDC-METIS TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0xDd7dF3522a49e6e1127bf1A1d3bAEa3bc100583B',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysm.USDC-METIS',
    earnedTokenAddress: '0x2d04969ED7D1b186797C44dF5F5634Eb9C89aF6b',
    earnContractAddress: '0x2d04969ED7D1b186797C44dF5F5634Eb9C89aF6b',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-metis-m.usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['mUSDC', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    createdAt: 1642623846,
  },
  {
    id: 'tethys-weth-metis',
    name: 'WETH-METIS LP',
    token: 'WETH-METIS TLP',
    tokenDescription: 'Tethys',
    tokenAddress: '0xEE5adB5b0DfC51029Aca5Ad4Bc684Ad676b307F7',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooTethysWETH-METIS',
    earnedTokenAddress: '0xbb8155672A297dE54E6E87d0755F03bd60B7f166',
    earnContractAddress: '0xbb8155672A297dE54E6E87d0755F03bd60B7f166',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tethys-weth-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tethys',
    assets: ['WETH', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://tethys.finance/pool/add?inputCurrency=METIS&outputCurrency=0x420000000000000000000000000000000000000A',
    buyTokenUrl:
      'https://tethys.finance/swap?inputCurrency=METIS&outputCurrency=0x420000000000000000000000000000000000000A',
    createdAt: 1642624056,
  },
  {
    id: 'netswap-nett-m.usdt',
    name: 'm.USDT-NETT LP',
    token: 'm.USDT-NETT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x7D02ab940d7dD2B771e59633bBC1ed6EC2b99Af1',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapm.USDT-NETT',
    earnedTokenAddress: '0x29C4C22eC7dF7e936Cb3e6C4A7E5eAE751C7d86B',
    earnContractAddress: '0x29C4C22eC7dF7e936Cb3e6C4A7E5eAE751C7d86B',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-nett-m.usdt',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['mUSDT', 'NETT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278/0xbb06dca3ae6887fabf931640f67cab3e3a16f4dc',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278&outputCurrency=0xbb06dca3ae6887fabf931640f67cab3e3a16f4dc',
    createdAt: 1642356425,
  },
  {
    id: 'netswap-nett-metis',
    name: 'METIS-NETT LP',
    token: 'METIS-NETT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x60312d4EbBF3617d3D33841906b5868A86931Cbd',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapMETIS-NETT',
    earnedTokenAddress: '0xC96b496F78d1a45D9cec6d628a75614ed230D6D4',
    earnContractAddress: '0xC96b496F78d1a45D9cec6d628a75614ed230D6D4',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-nett-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['METIS', 'NETT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_MEDIUM',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278/0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278&outputCurrency=0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000',
    createdAt: 1642362780,
  },
  {
    id: 'netswap-nett-m.usdc',
    name: 'm.USDC-NETT LP',
    token: 'm.USDC-NETT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x0724d37522585E87d27C802728E824862Dc72861',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapmUSDC-NETT',
    earnedTokenAddress: '0x89E6F4dba7337F123D9915ADF2B61B8d8c2bCA31',
    earnContractAddress: '0x89E6F4dba7337F123D9915ADF2B61B8d8c2bCA31',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-nett-m.usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['mUSDC', 'NETT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278/0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    createdAt: 1642363788,
  },
  {
    id: 'netswap-bnb-nett-eol',
    name: 'BNB-NETT LP',
    token: 'BNB-NETT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x3bF77b9192579826f260Bc48F2214Dfba840fcE5',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapBNB-NETT',
    earnedTokenAddress: '0x92EB8b4A8fF3df4A610BC59D1e704550dBB978DE',
    earnContractAddress: '0x92EB8b4A8fF3df4A610BC59D1e704550dBB978DE',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-bnb-nett',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    retireReason: 'rewards',
    platform: 'Netswap',
    assets: ['BNB', 'NETT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278/0x2692BE44A6E38B698731fDDf417d060f0d20A0cB',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278&outputCurrency=0x2692BE44A6E38B698731fDDf417d060f0d20A0cB',
    createdAt: 1642364144,
  },
  {
    id: 'netswap-weth-nett',
    name: 'WETH-NETT LP',
    token: 'WETH-NETT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0xC8aE82A0ab6AdA2062B812827E1556c0fa448dd0',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapWETH-NETT',
    earnedTokenAddress: '0x3DD36E64784FDAEe7BD202c78322a0d8EB1BB32b',
    earnContractAddress: '0x3DD36E64784FDAEe7BD202c78322a0d8EB1BB32b',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-weth-nett',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['WETH', 'NETT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_LOW',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278/0x420000000000000000000000000000000000000A',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x90fe084f877c65e1b577c7b2ea64b8d8dd1ab278&outputCurrency=0x420000000000000000000000000000000000000A',
    createdAt: 1642363913,
  },
  {
    id: 'netswap-weth-metis',
    name: 'WETH-METIS LP',
    token: 'WETH-METIS LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x59051B5F5172b69E66869048Dc69D35dB0B3610d',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapWETH-METIS',
    earnedTokenAddress: '0xB84486eA8B34C65cD3bf3DeeB6990AA0a27a2EaF',
    earnContractAddress: '0xB84486eA8B34C65cD3bf3DeeB6990AA0a27a2EaF',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-weth-metis',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['WETH', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000/0x420000000000000000000000000000000000000A',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000&outputCurrency=0x420000000000000000000000000000000000000A',
    createdAt: 1642364450,
  },
  {
    id: 'netswap-m.usdt-metis-eol',
    name: 'm.USDT-METIS LP',
    token: 'm.USDT-METIS LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x3D60aFEcf67e6ba950b499137A72478B2CA7c5A1',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapm.USDT-METIS',
    earnedTokenAddress: '0x085bf6f912A42D0d8Ed53D4998b07F9A535315f0',
    earnContractAddress: '0x085bf6f912A42D0d8Ed53D4998b07F9A535315f0',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-m.usdt-metis',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    retireReason: 'rewards',
    platform: 'Netswap',
    assets: ['mUSDT', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000/0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000&outputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    createdAt: 1642365041,
  },
  {
    id: 'netswap-metis-m.usdc',
    name: 'm.USDC-METIS LP',
    token: 'm.USDC-METIS LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x5Ae3ee7fBB3Cb28C17e7ADc3a6Ae605ae2465091',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapm.USDC-METIS',
    earnedTokenAddress: '0xD602655aAF104106E880221b124A20891f769dE1',
    earnContractAddress: '0xD602655aAF104106E880221b124A20891f769dE1',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-metis-m.usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['mUSDC', 'METIS'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000/0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0xDeadDeAddeAddEAddeadDEaDDEAdDeaDDeAD0000&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    createdAt: 1642365277,
  },
  {
    id: 'netswap-weth-m.usdt-eol',
    name: 'm.USDT-WETH LP',
    token: 'm.USDT-WETH LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x4Db4CE7f5b43A6B455D3c3057b63A083b09b8376',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapm.USDT-WETH',
    earnedTokenAddress: '0xdcabA5d3907283a470Ad171eA6b722bCD6540c78',
    earnContractAddress: '0xdcabA5d3907283a470Ad171eA6b722bCD6540c78',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-weth-m.usdt',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    retireReason: 'rewards',
    platform: 'Netswap',
    assets: ['mUSDT', 'WETH'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x420000000000000000000000000000000000000A/0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x420000000000000000000000000000000000000A&outputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC',
    createdAt: 1642365495,
  },
  {
    id: 'netswap-weth-m.usdc',
    name: 'm.USDC-WETH LP',
    token: 'm.USDC-WETH LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0xF5988809ac97C65121e2c34f5D49558e3D12C253',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapm.USDC-WETH',
    earnedTokenAddress: '0x85f287c860f02bAc3aE5023eFb547b6B7Aa4D9eD',
    earnContractAddress: '0x85f287c860f02bAc3aE5023eFb547b6B7Aa4D9eD',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-weth-m.usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['mUSDC', 'WETH'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0x420000000000000000000000000000000000000A/0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0x420000000000000000000000000000000000000A&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    createdAt: 1642365777,
  },
  {
    id: 'netswap-m.usdt-m.usdc',
    name: 'm.USDC-m.USDT LP',
    token: 'm.USDC-m.USDT LP',
    tokenDescription: 'Netswap',
    tokenAddress: '0x1caD5f8f5D4C0AD49646B2565CC0cA725E4280EA',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooNetswapm.USDC-m.USDT',
    earnedTokenAddress: '0x2dC73D17Ae01De6D49aab45668601591FF283dee',
    earnContractAddress: '0x2dC73D17Ae01De6D49aab45668601591FF283dee',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'netswap-m.usdt-m.usdc',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Netswap',
    assets: ['mUSDC', 'mUSDT'],
    risks: [
      'COMPLEXITY_LOW',
      'BATTLE_TESTED',
      'IL_HIGH',
      'MCAP_HIGH',
      'AUDIT',
      'CONTRACTS_VERIFIED',
    ],
    stratType: 'StratLP',
    addLiquidityUrl:
      'https://netswap.io/#/add/0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC/0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    buyTokenUrl:
      'https://netswap.io/#/swap?inputCurrency=0xbB06DCA3AE6887fAbF931640f67cab3e3a16F4dC&outputCurrency=0xEA32A96608495e54156Ae48931A7c20f0dcc1a21',
    createdAt: 1642365937,
  },
];
